<template>
  <div class="flex items-center">
    <vs-avatar
      :src="avatar"
      :text="avatarText"
      :color="AISEA_COLOR.LIGHT_BLUE"
      class="flex-shrink-0 mr-2"
      size="30px"
      @click="onClickNameLink"
    />
    <p @click="onClickNameLink" class="text-inherit link-string">
      {{ params.value }}
    </p>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import { ColorMixin } from "@/mixins";
export default {
  name: "CellRendererCrewName",
  mixins: [ColorMixin],
  data() {
    return {
      avatar: null,
      avatarText: "",
    };
  },
  created() {
    if (this.params.data.picture) {
      storage
        .child(this.params.data.picture.thumbnail_path)
        .getDownloadURL()
        .then(response => {
          this.avatar = response;
        });
    }
  },
  methods: {
    onClickNameLink() {
      /*
      this.$router.push({
        name: "enterprise-management-manning-vessels-list",
        params: { id: this.params.data.id },
      });
      */

      const routeData = this.$router.resolve({
        name: "enterprise-management-manning-vessels-list",
        params: { id: this.params.data.id },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.link-string {
  color: $aisea-blue;
  cursor: pointer;
}
</style>
